import React from 'react';
import Reveal from './Reveal';
import './courseKit.css';

/**
 * "Details to know" strip.
 *
 * Each fact is a complete designed card with its text rendered into the image,
 * rather than an icon glyph sitting above DOM text. Rob's call (2026-08-04):
 * the icon-plus-number version looked cheap, and generated art carries far
 * more when the typography is part of the composition.
 *
 * The words are still in the DOM as visually-hidden text so screen readers and
 * crawlers get them. Baking text into an image must never be the only copy of
 * that text.
 */
const FactStrip = ({ facts = [] }) => {
  if (!facts.length) return null;

  return (
    <section className="ck-facts" aria-label="Course details">
      <Reveal>
        <ul className="ck-facts-list">
          {facts.map((fact, i) => (
            <li key={fact.label}>
              {fact.card ? (
                <>
                  <img className="ck-fact-card" src={fact.card} alt="" loading="lazy"
                    style={{ animationDelay: `${i * 90}ms` }} />
                  <span className="ck-visually-hidden">{fact.value} {fact.label}</span>
                  {/* A headline number with no explanation next to it is not
                      worth much. Say what it actually means. */}
                  {fact.blurb ? <p className="ck-fact-blurb">{fact.blurb}</p> : null}
                </>
              ) : (
                <>
                  <span className="ck-fact-value">{fact.value}</span>
                  <span className="ck-fact-label">{fact.label}</span>
                </>
              )}
            </li>
          ))}
        </ul>
      </Reveal>
    </section>
  );
};

export default FactStrip;
